export default {
  "account": {
    "curatedCollections": "Kuratoidut kokoelmat",
    "curatedCollectionsInfo": "Etsi alta kaikki kuratoimiasi kokoelmia",
    "editProfile": "Muokkaa profiilia",
    "likes": "Tykätyt",
    "linkAccount": "Oma tili",
    "linkLogin": "Kirjaudu sisään",
    "linkLoginJoin": "Kirjaudu/Liity",
    "linkLogout": "Kirjaudu ulos",
    "myProfile": "Profiilini",
    "notifications": {
      "loggedIn": "Olet nyt kirjautunut sisään. Tervetuloa!",
      "loggedOut": "Olet nyt kirjautunut ulos.",
      "noCollections": {
        "curated": "Et ole vielä kuratoinut yhtään kokoelmaa",
        "private": "Et ole luonut vielä yksityisiä gallerioita",
        "public": "Et ole luonut vielä julkisia gallerioita"
      },
      "noLikedItems": "Et ole tykännyt vielä mistään kohteista"
    },
    "privateCollections": "Yksityiset galleriat",
    "profile": "Omat tykkäykset ja galleriat",
    "profileSettings": "Profiiliasetukset",
    "publicCollections": "Julkiset galleriat",
    "settings": "Asetukset",
    "title": "Oma tili"
  },
  "actions": {
    "accept": "Hyväksy",
    "cancel": "Peruuttaa",
    "close": "sulje",
    "continue": "jatka",
    "download": "Lataa",
    "edit": "Muokkaa",
    "feedback": "Palaute",
    "goBack": "Palaa takaisin",
    "goHome": "Siirry kotisivulle",
    "learnMore": "Opi lisää",
    "like": "Tykkää",
    "move": "Liikkua",
    "next": "Seuraava",
    "pin": "Pin",
    "preview": "Esikatselu",
    "previous": "Edellinen",
    "providedBy": "Tarjoaa {provider}",
    "reject": "Hylätä",
    "save": "Tallenna",
    "send": "Lähettää",
    "share": "Jaa",
    "shareOn": "Jaa mediassa {social}",
    "skip": "Ohita",
    "viewAt": "Näytä osoitteessa {link}",
    "viewDocument": "Näytä asiakirja"
  },
  "attribution": {
    "country": "Maa:",
    "creator": "Luoja:",
    "date": "Päivämäärä:",
    "institution": "kulttuuriperintölaitos",
    "title": "Nimi:"
  },
  "automatedCardGroup": {
    "item": "Viimeisimmät kohdetta",
    "organisation": "Organisaatiot",
    "place": "Paikat",
    "time": "Esillä vuosisatoja",
    "topic": "Esillä olevat aiheet"
  },
  "blog": {
    "author": "Kirjoittaja",
    "authors": "Kirjoittajat",
    "blog": "Blogi",
    "by": "laatija",
    "categories": "Luokat",
    "category": "Kategoria",
    "posts": "Blogijulkaisut",
    "published": "Julkaistu {date}",
    "relatedPosts": "Aiheeseen liittyvät julkaisut"
  },
  "cardLabels": {
    "organisation": "Organisaatio",
    "person": "Henkilö",
    "place": "Paikka",
    "theme": "Teema",
    "time": "Vuosisata",
    "topic": "Aihe"
  },
  "clearAllFilters": "tyhjennä kaikki suodattimet",
  "collections": {
    "actions": {
      "edit": "Muokkaa kokoelmaa",
      "update": "Päivitä kokoelma"
    },
    "fashion": {
      "facets": {
        "CREATOR": {
          "moreName": "suunnittelijat",
          "name": "Suunnittelija | Suunnittelijat",
          "select": "Valitse suunnittelijat"
        },
        "proxy_dc_format": {
          "moreName": "tekniikat",
          "name": "Tekniikka | Tekniikat",
          "select": "Valitse tekniikat"
        },
        "proxy_dc_type": {
          "moreName": "esine tyypit",
          "name": "Kohteen tyyppi | Kohdetyypit",
          "select": "Valitse esine tyypit"
        },
        "proxy_dcterms_medium": {
          "moreName": "materiaaleja",
          "name": "Materiaali | Materiaalit",
          "select": "Valitse materiaalit"
        }
      }
    },
    "form": {
      "description": "Kuvaus"
    },
    "notifications": {
      "update": "Kokoelma on päivitetty"
    }
  },
  "collectionsYouMightLike": "Saattaisit tykätä näistä kokoelmista",
  "colourSwatch": "Värimalli",
  "contentYouMightLike": "Saattaisit tykätä näistä sisällöistä",
  "contentfulManual": {
    "footerNavigation": {
      "MoreInfoLabel": "Lisätietoja",
      "about": "Tietoja Europeana",
      "forDevelopers": "Kehittäjille",
      "help": "Apua",
      "meetUs": "Tutustu tiimiin",
      "provide": "Ryhdy tietojentarjoajaksi",
      "subscribe": "Tilaa uutiskirjeemme",
      "terms": "Käyttöehdot ja tietosuojakäytäntö"
    },
    "headerNavigation": {
      "Collections": "Kokoelmat",
      "explore": "tutustu",
      "teachers": "Opettajat"
    }
  },
  "curatedAutomatically": "Europeanan automaattisesti kuratoima",
  "dateFilter": {
    "endDate": "Päättymispäivämäärä",
    "specificDate": "Tietty päivämäärä",
    "startDate": "Aloituspäivämäärä",
    "to": "asti"
  },
  "debug": {
    "apiRequests": {
      "apiKeyLinkText": "Europeana API avain",
      "noRequests": "Tällä sivulla ei käytetty Europeanan API-pyyntöjä.",
      "settingsPageLinkText": "asetukset-sivu",
      "tip": "Vinkki: jos sinulla on jo {apiKeyLink} , voit kirjoittaa sen {settingsPageLink} -sivulle ja se sisällytetään näihin API-pyyntölinkkeihin.",
      "title": "API-pyynnöt"
    },
    "debug": "Virheenkorjaus",
    "settings": {
      "form": {
        "apiKey": {
          "description": "Anna Europeana API -avaimesi, niin sitä käytetään API-pyyntöjen linkeissä.",
          "label": "API-avain"
        },
        "enabled": {
          "description": "Jos käytössä, virheenkorjausvalikko näkyy sivun alatunnisteessa.",
          "label": "Ota virheenkorjausvalikko käyttöön"
        }
      },
      "title": "Asetukset"
    }
  },
  "delete": "Poista",
  "depiction": "Kuvaus kohteesta {title}",
  "directions": {
    "left": "Vasen",
    "right": "Oikea"
  },
  "edmIsShownAtLinkAlt": "Näytä palveluntarjoajan verkkosivustolla",
  "entity": {
    "actions": {
      "cancel": "Peruuta",
      "pin": "Kiinnitä kohde",
      "unpin": "Irrota kohde",
      "viewPinned": "Katso kiinnitetyt kohteet"
    },
    "labels": {
      "entity": "Yksikkö"
    },
    "notifications": {
      "deleted": "Galleriasi on poistettu.",
      "error": {
        "unpin": "Kohteen irrottamisessa tapahtui virhe. Yritä uudelleen tai ilmoita ongelmasta."
      },
      "pin": "Tämä kohde näkyy kokoelman \" {entity} \" yläosassa. Ilmoitamme sinulle, kun tämä muutos tulee näkyviin kokoelmasivulle.",
      "pinLimit": {
        "body": "Tällä hetkellä voit kiinnittää vain 24 kohdetta ensimmäiselle sivulle. Jos haluat kiinnittää tämän kohteen, irrota toinen ja yritä sitten kiinnittää tämä uudelleen.",
        "title": "Liian monta kiinnitettyä kohdetta"
      },
      "pinned": "Kohde on kiinnitetty. Se on nyt tämän kokoelman ensimmäisen sivun yläosassa. Saattaa kestää jopa 24 tuntia, ennen kuin se näkyy kaikille.",
      "select": "Valitse liittyvä kokonaisuus, jos haluat liittää kohteen siihen tai irrottaa sen siitä.",
      "unpin": "Tämä kohde lakkaa näkymästä kokoelman \" {entity} \" yläosassa. Ilmoitamme sinulle, kun tämä muutos tulee näkyviin kokoelmasivulle.",
      "unpinned": "Kohde on irrotettu. Se ei ole enää tämän kokoelman ensimmäisen sivun yläosassa. Kaikkien katoaminen voi kestää jopa 24 tuntia."
    }
  },
  "error": "Virhe",
  "errorMessage": {
    "galleryUnauthorised": {
      "description": "Tämä ei ole mahdollista, koska yksityiset galleriat näkyvät vain niiden luojalle. Jos tunnet gallerian luojan, pyydä häntä tekemään galleriasta julkinen. Vaihtoehtoisesti voit ilmoittaa tästä ongelmasta palautepainikkeella.",
      "metaTitle": "Galleria luvaton",
      "title": "Oho! {newline} Yrität tarkastella toisen henkilön yksityistä galleriaa."
    },
    "itemNotFound": {
      "description": "Tämä voi johtua seuraavista syistä: tätä kohdetta ei ole olemassa tai; se poistettiin, koska se ei vastannut laatukriteereitämme tai; se päivitettiin ja julkaistiin uudelleen uudella yksilöivällä tunnisteella. Yritä siinä tapauksessa löytää kohde uudelleen.",
      "metaTitle": "Kohdetta ei löydy",
      "title": "Voi ei! {newline} Emme löytäneet tätä kohdetta."
    }
  },
  "exhibitions": {
    "chapters": "Luvut",
    "credits": "Tekijät",
    "currentChapter": "Nykyinen luku",
    "description": "Tutustu näyttelyihin",
    "exhibitions": "Näyttelyt"
  },
  "explore": "tutustu",
  "facets": {
    "COLOURPALETTE": {
      "moreName": "värit",
      "name": "Väri | värit",
      "options": {
        "#000000": "Musta",
        "#000080": "Laivastonsininen",
        "#00008B": "Tummansininen",
        "#0000CD": "Keskikokoinen sininen",
        "#0000FF": "Sininen",
        "#006400": "Tummanvihreä",
        "#008000": "Web Green",
        "#008080": "tavi",
        "#008B8B": "Tumma syaani",
        "#00BFFF": "Syvä taivas sininen",
        "#00CED1": "Tumma turkoosi",
        "#00FA9A": "Keskikokoinen keväänvihreä",
        "#00FF00": "Vihreä",
        "#00FF7F": "Keväänvihreä",
        "#00FFFF": "syaani",
        "#191970": "Yönsininen",
        "#1E90FF": "Dodger-sininen",
        "#20B2AA": "Vaaleanmeren vihreä",
        "#228B22": "Metsänvihreä",
        "#2E8B57": "Meren vihreä",
        "#2F4F4F": "Tumma liuskekivi harmaa",
        "#32CD32": "Limenvihreä",
        "#3CB371": "Keskipitkä meri vihreä",
        "#40E0D0": "Turkoosi",
        "#4169E1": "Kuninkaallisen sininen",
        "#4682B4": "Teräs sininen",
        "#483D8B": "Tumma liuskekivi sininen",
        "#48D1CC": "Keskikokoinen turkoosi",
        "#4B0082": "Indigo",
        "#556B2F": "Tumma oliivi vihreä",
        "#5F9EA0": "Kadetinsininen",
        "#6495ED": "Ruiskaunokki",
        "#663399": "Rebecca Violetti",
        "#66CDAA": "Keskikokoinen akvamariini",
        "#696969": "Dim Gray",
        "#6A5ACD": "Liuskekivi sininen",
        "#6B8E23": "Olive Drab",
        "#708090": "Liuskekivi Harmaa",
        "#778899": "Vaalea liuskekivi harmaa",
        "#7B68EE": "Keskikokoinen liuskekivi sininen",
        "#7CFC00": "Nurmikko vihreä",
        "#7F0000": "Web Maroon",
        "#7F007F": "Web Purppura",
        "#7FFF00": "Keltaisen vihreä",
        "#7FFFD4": "Akvamariini",
        "#800000": "Kastanjanruskea",
        "#800080": "Violetti",
        "#808000": "Oliivi",
        "#808080": "Verkkoharmaa",
        "#87CEEB": "Taivaansininen",
        "#87CEFA": "Vaalean taivaansininen",
        "#8A2BE2": "Sininen Violetti",
        "#8B0000": "Tummanpunainen",
        "#8B008B": "Tumma magenta",
        "#8B4513": "Nahanruskea",
        "#8FBC8F": "Tumma meri vihreä",
        "#90EE90": "Vaaleanvihreä",
        "#9370DB": "Keskipitkän violetti",
        "#9400D3": "Tumma violetti",
        "#98FB98": "Vaaleanvihreä",
        "#9932CC": "Dark Orchid",
        "#9ACD32": "Keltainen vihreä",
        "#A020F0": "Violetti",
        "#A0522D": "Sienna",
        "#A52A2A": "Ruskea",
        "#A9A9A9": "Tummanharmaa",
        "#ADD8E6": "Vaaleansininen",
        "#ADFF2F": "Vihreä keltainen",
        "#AFEEEE": "Kalpea turkoosi",
        "#B03060": "Kastanjanruskea",
        "#B0C4DE": "Light Steel Blue",
        "#B0E0E6": "Puuterinsininen",
        "#B22222": "Tulenkestävä tiili",
        "#B8860B": "Dark Goldenrod",
        "#BA55D3": "Medium Orchid",
        "#BC8F8F": "Rosy Brown",
        "#BDB76B": "Tumma khaki",
        "#BEBEBE": "Harmaa",
        "#C0C0C0": "Hopea",
        "#C71585": "Medium Violet Red",
        "#CD5C5C": "Indian Red",
        "#CD853F": "Peru",
        "#D2691E": "Suklaa",
        "#D2B48C": "rusketus",
        "#D3D3D3": "Vaalean harmaa",
        "#D8BFD8": "Ohdake",
        "#DA70D6": "Orkidea",
        "#DAA520": "Kultapiisku",
        "#DB7093": "Vaalean violetti punainen",
        "#DC143C": "Karmiininpunainen",
        "#DCDCDC": "Gainsboro",
        "#DDA0DD": "Luumu",
        "#DEB887": "oksainen puucolor",
        "#E0FFFF": "Vaalea syaani",
        "#E6E6FA": "Laventeli",
        "#E9967A": "Tumma lohi",
        "#EE82EE": "Violetti",
        "#EEE8AA": "Kalpea Goldenrod",
        "#F08080": "Light Coral",
        "#F0E68C": "Khaki",
        "#F0F8FF": "Alice Blue",
        "#F0FFF0": "hunajameloni",
        "#F0FFFF": "Taivaansininen",
        "#F4A460": "Sandy Brown",
        "#F5DEB3": "Vehnä",
        "#F5F5DC": "Beige",
        "#F5F5F5": "Valkoinen savu",
        "#F5FFFA": "Minttuvoide",
        "#F8F8FF": "Ghost White",
        "#FA8072": "Lohi",
        "#FAEBD7": "Antiikki valkoinen",
        "#FAF0E6": "Liinavaatteet",
        "#FAFAD2": "Kevyt Goldenrod",
        "#FDF5E6": "Vanha pitsi",
        "#FF0000": "Punainen",
        "#FF00FF": "fuksia",
        "#FF1493": "Deep Pink",
        "#FF4500": "Oranssinpunainen",
        "#FF6347": "Tomaatti",
        "#FF69B4": "Hot Pink",
        "#FF7F50": "Koralli",
        "#FF8C00": "Tummanoranssi",
        "#FFA07A": "Vaalea lohenpunainen",
        "#FFA500": "Oranssi",
        "#FFB6C1": "Vaalea pinkki",
        "#FFC0CB": "Pinkki",
        "#FFD700": "Kulta",
        "#FFDAB9": "Persikka",
        "#FFDEAD": "Navajo Valkoinen",
        "#FFE4B5": "Moccasin",
        "#FFE4C4": "Bisque",
        "#FFE4E1": "Misty Rose",
        "#FFEBCD": "Blanched manteli",
        "#FFEFD5": "Papaya Whip",
        "#FFF0F5": "Laventeli poskipuna",
        "#FFF5EE": "Kotilo",
        "#FFF8DC": "Cornsilk",
        "#FFFACD": "Sitruuna-sifonki",
        "#FFFAF0": "Kukka valkoinen",
        "#FFFAFA": "Lumi",
        "#FFFF00": "Keltainen",
        "#FFFFE0": "Vaaleankeltainen",
        "#FFFFF0": "Norsunluu",
        "#FFFFFF": "Valkoinen"
      },
      "select": "Valitse värit"
    },
    "COUNTRY": {
      "name": "Alkuperämaa",
      "options": {
        "Albania": "Albania",
        "Austria": "Itävalta",
        "Belarus": "Valko-Venäjä",
        "Belgium": "Belgia",
        "Bosnia and Herzegovina": "Bosnia ja Hertsegovina",
        "Bulgaria": "Bulgaria",
        "Croatia": "Kroatia",
        "Cyprus": "Kypros",
        "Czech Republic": "Tšekin tasavalta",
        "Denmark": "Tanska",
        "Estonia": "Viro",
        "Europe": "Eurooppa",
        "Finland": "Suomi",
        "France": "Ranska",
        "Georgia": "Georgia",
        "Germany": "Saksa",
        "Greece": "Kreikka",
        "Holy See (Vatican City State)": "Pyhä istuin (Vatikaanivaltio)",
        "Hungary": "Unkari",
        "Iceland": "Islanti",
        "Ireland": "Irlanti",
        "Israel": "Israel",
        "Italy": "Italia",
        "Latvia": "Latvia",
        "Lithuania": "Liettua",
        "Luxembourg": "Luxemburg",
        "Macedonia": "Makedonia",
        "Malta": "Malta",
        "Moldova": "Moldova",
        "Montenegro": "Montenegro",
        "Netherlands": "Alankomaat",
        "Norway": "Norja",
        "Poland": "Puola",
        "Portugal": "Portugali",
        "Romania": "Romania",
        "Russia": "Venäjä",
        "Serbia": "Serbia",
        "Slovakia": "Slovakia",
        "Slovenia": "Slovenia",
        "Spain": "Espanja",
        "Sweden": "Ruotsi",
        "Switzerland": "Sveitsi",
        "Turkey": "Turkki",
        "Ukraine": "Ukraina",
        "United Kingdom": "Yhdistynyt kuningaskunta",
        "United States of America": "Yhdysvallat"
      },
      "select": "Valitse tarjottavat maat"
    },
    "CREATOR": {
      "moreName": "luojat",
      "name": "Tekijä  |  Tekijät",
      "select": "Valitse tekijät"
    },
    "DATA_PROVIDER": {
      "moreName": "kulttuurilaitoksista",
      "name": "kulttuuriperintölaitos",
      "select": "valitse kulttuuriperintölaitos"
    },
    "IMAGE_ASPECTRATIO": {
      "name": "Kuvan suunta | Kuvan suunnat",
      "options": {
        "landscape": "Maisema",
        "portrait": "Muotokuva"
      },
      "select": "Valitse kuvan suunnat"
    },
    "IMAGE_SIZE": {
      "name": "Kuvakoko | Kuvien koot",
      "options": {
        "extra_large": "Erittäin suuri, 4 megapikseliä + (esim. 2688 x 1520 pikseliä)",
        "large": "Suuri, 1-4 megapikseliä (esim. 1920 x 1080 pikseliä)",
        "medium": "Keskikokoinen, 0,5–1 megapikseliä (esim. 850 x 850 pikseliä)",
        "small": "Pieni, < 0,5 megapikseliä (esim. 650 x 600 pikseliä)"
      },
      "select": "Valitse kuvakoot"
    },
    "LANGUAGE": {
      "name": "Kieli",
      "options": {
        "ar": "Arabialainen",
        "bg": "Bulgarialainen",
        "bs": "Bosnialainen",
        "ca": "Katalaani",
        "cs": "Tšekki",
        "cy": "Walesin",
        "da": "Tanskalainen",
        "de": "Saksan",
        "el": "Kreikkalainen",
        "en": "Englanti",
        "es": "Espanjan",
        "et": "Viron",
        "fi": "Suomalainen",
        "fr": "Ranskan",
        "ga": "Irlantilainen",
        "gd": "Gaeli",
        "he": "Heprea",
        "hr": "Kroatian",
        "hu": "Unkarilainen",
        "is": "Islantilainen",
        "it": "Italialainen",
        "lt": "Liettuan",
        "lv": "Latvialainen",
        "mk": "Makedonialainen",
        "mt": "Maltalainen",
        "mul": "Useita kieliä",
        "nl": "Hollantilainen",
        "no": "Norjalainen",
        "pl": "Puolan",
        "pt": "Portugalin",
        "ro": "Romanialainen",
        "ru": "Venäläinen",
        "sk": "Slovakki",
        "sl": "Sloveeni",
        "sq": "Albanian",
        "sr": "Serbialainen",
        "sv": "Ruotsalainen",
        "tr": "Turkkilainen",
        "uk": "Ukrainan"
      },
      "select": "Valitse kielet"
    },
    "MIME_TYPE": {
      "name": "Tiedostomuoto | Tiedostomuodot",
      "options": {
        "text/plain": "Pelkkä teksti"
      },
      "select": "Valitse tiedostomuodot"
    },
    "PROVIDER": {
      "moreName": "aggregaattoreita",
      "name": "Kokoaja",
      "select": "Valitse aggregaattoreita"
    },
    "REUSABILITY": {
      "name": "Voinko käyttää tätä?",
      "options": {
        "open": "Kyllä",
        "permission": "Ehkä, pyydä lupaa",
        "restricted": "Kyllä, tietyin ehdoin",
        "uncategorized": "Ei luokiteltu"
      },
      "select": "Valitse, voitko käyttää tätä"
    },
    "TYPE": {
      "name": "Mediatyyppi",
      "options": {
        "3D": "3D",
        "IMAGE": "Kuva",
        "SOUND": "Ääni",
        "TEXT": "Teksti",
        "VIDEO": "Video"
      },
      "select": "Valitse mediatyypit"
    },
    "api": {
      "name": "Hae",
      "options": {
        "fulltext": "Tallentaa koko tekstin kanssa",
        "metadata": "Vain metatiedot"
      },
      "switch": "Haku vain kohteiden sisällöstä, joissa on kokoteksti.",
      "switchMoreInfo": "Tässä kokoelmassa voit valita, mitä haluat etsiä: jos tämä kytkin on päällä, etsit sanomalehti- ja asiakirjateksteistä; jos se on pois päältä, etsit sen sijaan kohteen kuvailutiedoista, aivan kuten useimmissa muissa kokoelmissa."
    },
    "button": {
      "apply": "Käytä",
      "cancel": "Peruuttaa",
      "morefilters": "Lisää suodattimia",
      "reset": "Nollaa",
      "showAll": "Näytä kaikki {label}",
      "showLess": "Näytä vähemmän {label}"
    },
    "collection": {
      "name": "Teema",
      "options": {
        "archaeology": "Arkeologia",
        "art": "Taide",
        "fashion": "Muoti",
        "industrial": "Teollisuusperintö",
        "manuscript": "Käsikirjoitukset",
        "map": "Kartat ja maantiede",
        "migration": "Muuttoliike",
        "music": "Musiikki",
        "nature": "Luonnonhistoria",
        "newspaper": "Sanomalehdet",
        "photography": "Valokuvaus",
        "sport": "Urheilu",
        "ww1": "Ensimmäinen maailmansota"
      },
      "select": "Valitse teema"
    },
    "contentTier": {
      "name": "Kohde laatu",
      "options": {
        "*": "Sisältää kohteita, jotka eivät täytä julkaisuehtojamme",
        "0": "Näytä ainoastaan kohteet, jotka eivät täytä julkaisuehtojamme",
        "1": "Heikko laatu",
        "2": "Keskilaatuinen",
        "3": "Korkealaatuinen ja uudelleenkäytettävä olosuhteissa",
        "4": "Korkealaatuinen & vapaasti uudelleenkäytettävissä"
      },
      "select": "Valitse tuotteiden ominaisuudet"
    },
    "moreOptions": "Hae löytääksesi {0} lisää {1} .",
    "proxy_dc_format": {
      "name": "Muoto | Muodot",
      "select": "Valitse formaatit"
    },
    "proxy_dc_type": {
      "name": "Tyyppi | Tyypit",
      "select": "Valitse tyypit"
    },
    "proxy_dcterms_issued": {
      "name": "Päivämäärä"
    },
    "proxy_dcterms_medium": {
      "name": "Media | Mediat",
      "select": "Valitse media"
    }
  },
  "feedback": {
    "emailOptional": "Saatamme haluta seurata asiaa. Kirjoita sähköpostiosoitteesi, jos olet iloinen siitä, että voimme ottaa sinuun yhteyttä.",
    "failed": "Pyyntö epäonnistui. Yritä uudelleen.",
    "form": {
      "placeholders": {
        "email": "Syötä sähköpostiosoitteesi",
        "feedback": "Kirjoita palautteesi tähän"
      }
    },
    "policies": "Jatkamalla hyväksyt {0} ja tunnustamme {1} .",
    "privacyPolicy": "Tietosuojakäytäntö",
    "success": "Palautteesi on lähetetty.",
    "termsOfService": "Käyttöehdot",
    "thankYou": "Kiitos!",
    "title": "Lähetä palautetta",
    "validEmail": "syötä voimassa oleva sähköpostiosoite",
    "validFeedback": "Palautteen tulee koostua vähintään viidestä sanasta"
  },
  "fieldLabels": {
    "default": {
      "dcContributor": "Myötävaikuttajat",
      "dcCoverage": "Paikka-aika",
      "dcCreator": "Luoja",
      "dcDate": "Päivämäärä",
      "dcDescription": "Kuvaus",
      "dcDuration": "Kesto",
      "dcFormat": "Muoto",
      "dcIdentifier": "Tunniste",
      "dcLanguage": "Kieli",
      "dcPublisher": "Julkaisija",
      "dcRelation": "Suhteet",
      "dcRights": "Oikeudet",
      "dcSource": "Lähde",
      "dcSubject": "Aihe",
      "dcTitle": "Nimi",
      "dcType": "Kohteen tyyppi",
      "dctermsCreated": "Luomispäivä",
      "dctermsExtent": "Laajuus",
      "dctermsHasPart": "Koostuu seuraavista:",
      "dctermsHasVersion": "-kohteessa on versio",
      "dctermsIsFormatOf": "on formaatti kohteelle",
      "dctermsIsPartOf": "On osa kohdetta",
      "dctermsIsReferencedBy": "-kohteeseen viittaa",
      "dctermsIsReplacedBy": "-kohteen vaihtaa",
      "dctermsIsRequiredBy": "Edellyttää kohteen",
      "dctermsIssued": "Julkaisupäivämäärä",
      "dctermsMedium": "Media",
      "dctermsProvenance": "Alkuperä",
      "dctermsReferences": "Viittaa kohteeseen",
      "dctermsSpatial": "Paikat",
      "dctermsTOC": "Sisällysluettelo",
      "dctermsTemporal": "Ajoitus",
      "edmCountry": "Alkuperämaa",
      "edmCurrentLocation": "Nykyinen sijainti",
      "edmDataProvider": "kulttuuriperintölaitos",
      "edmHasMet": "On tavannut henkilön",
      "edmIncorporates": "Sisältää",
      "edmIntermediateProvider": "Välillinen tarjoaja",
      "edmIsDerivativeOf": "On johdannainen kohteesta",
      "edmIsRelatedTo": "On sukua",
      "edmIsRepresentationOf": "Kuvaa kohdetta",
      "edmIsSimilarTo": "On samanlainen kuin",
      "edmIsSuccessorOf": "On seuraaja kohteelle",
      "edmProvider": "Tarjoaja",
      "edmRealizes": "Sisältää",
      "edmRights": "Tämän tietueen median lisenssi (ellei toisin mainita)",
      "edmUgc": "Käyttäjien tuottama sisältö",
      "europeanaCollectionName": "Kokoelman nimi",
      "keywords": "Avainsanat (yhteisön tarjoamat)",
      "timestampCreated": "Aikaleima luotu",
      "timestampUpdate": "Aikaleima päivitetty",
      "wasPresentAt": "Oli läsnä paikassa",
      "year": "Vuosi"
    },
    "webResource": {
      "about": "RDF-tiedot",
      "dcDescription": "Kuvaus",
      "ebucoreHasMimeType": "Ebucore MIME -tyyppi",
      "edmRights": "Tämän mediaresurssin lisenssi",
      "rdfAbout": "RDF-tiedot"
    }
  },
  "filter": "Suodattaa",
  "filterResults": "Suodata tulokset",
  "footer": {
    "customiseWebsiteLanguage": "Muokkaa verkkosivuston kieltä",
    "disclaimerLine1": "Europeana on Euroopan unionin aloite, jonka rahoittavat Euroopan unionin Verkkojen Eurooppa -väline ja Euroopan unionin jäsenvaltiot. Europeana-palveluja, mukaan lukien tämä verkkosivusto, ylläpitää konsortio, jota johtaa Europeana-säätiö Euroopan komission kanssa tehtyyn palvelusopimukseen.",
    "disclaimerLine2": "Euroopan komissio ei takaa tietojen paikkansapitävyyttä eikä ota mitään vastuuta tämän verkkosivuston tiedoista. Kumpikaan Euroopan komissio tai kukaan Euroopan komission puolesta toimiva henkilö ei ole vastuussa tai vastuussa tämän verkkosivuston tietojen oikeellisuudesta tai käytöstä.",
    "findUsElsewhere": "Löydä meidät muualta",
    "imageDescription": "Euroopan unionin rahoittama",
    "navigation": {
      "MoreInfoLabel": "Lisätietoja",
      "about": "Tietoa meistä",
      "accessibility": "Saavutettavuus",
      "cookies": "Evästeet",
      "forDevelopers": "Kehittäjille",
      "help": "Apua",
      "privacy": "Tietosuojakäytäntö",
      "provide": "Ryhdy tietojentarjoajaksi",
      "subscribe": "Tilaa uutiskirjeemme",
      "terms": "Käyttöehdot"
    },
    "ourMission": "Tehtävämme",
    "ourMissionQuote": "Europeana edesauttaa kulttuuriperinnön digitaalista muodonmuutosta. Kehitämme asiantuntemusta, välineitä ja menettelytapoja digitaalisen muutoksen omaksumiseksi ja kannustamme innovaatioita edistäviä kumppanuuksia."
  },
  "formatting": {
    "ellipsis": "...",
    "listSeperator": ";"
  },
  "galleries": {
    "description": "Tutustu gallerioihimme",
    "galleries": "Galleriat"
  },
  "goToRecord": "Siirry tietueeseen",
  "header": {
    "backToMenu": "Sulje hakuruutu",
    "clearQuery": "Tyhjennä hakuehdot",
    "closeSidebar": "Sulje valikko",
    "entireCollection": "Hae ehdoilla {query} koko kokoelmastamme",
    "europeanaHome": "Europeanan kotisivu",
    "inCollection": "Hae ehdoilla {query} kokoelmasta {collection}",
    "navigation": {
      "about": "Tietoa meistä",
      "collections": "Kokoelmat",
      "europeanaClassroom": "Opettajille",
      "help": "Apua",
      "home": "Koti",
      "pro": "Ammattilaisille",
      "stories": "Tarinoita"
    },
    "quickSearch": "Pikahaku",
    "searchFor": "Hae ehdoilla {query}",
    "searchForEverything": "Hae kaikkea",
    "searchForEverythingInCollection": "Hae kaikkea kokoelmasta {collection}",
    "searchForEverythingInEntireCollection": "Hae kaikkea koko kokoelmastamme",
    "searchForm": "Hakulomake",
    "showSidebar": "Näytä valikko",
    "sideNavigation": "Sivunavigointi"
  },
  "homeLinkAlt": "Europeanan kotisivu",
  "homePage": {
    "discoverEditorial": "Uusimmat tarinat",
    "storiesCTA": "Katso kaikki tarinat",
    "subHeadline": "Etsi, tallenna ja jaa taidetta, kirjoja, elokuvia ja musiikkia tuhansista kulttuurilaitoksista",
    "themesCTA": "Katso kaikki teemat",
    "themesTitle": "Tutustu teemoittain",
    "title": "Tutustu Euroopan {digital} kulttuuriperintöön",
    "titleDigital": "digitaaliseen"
  },
  "imageSlider": {
    "handle": "Liukusäätimen kahva"
  },
  "items": {
    "itemCount": "1 kohde |{count} kohdetta",
    "itemOf": "{max} / {count} kohdetta",
    "recent": "Viimeisimmät kohteet",
    "recommended": "Suositellut kohteet",
    "youMightLike": "Saattaisit tykätä näistä kohteista"
  },
  "klaro": {
    "main": {
      "acceptAll": "Hyväksy kaikki",
      "acceptSelected": "Hyväksy valittu",
      "consentModal": {
        "description": "Suhtaudumme tietosuojaasi vakavasti. Täällä voit arvioida ja mukauttaa palveluja, joita haluaisimme käyttää tällä verkkosivustolla. Sinä olet vastuussa! Ota palvelut käyttöön tai poista ne käytöstä mielesi mukaan.",
        "title": "Palvelut, joita haluaisimme käyttää."
      },
      "consentNotice": {
        "description": "Välitämme yksityisyydestäsi ja käytämme tietoja vain kokemuksesi parantamiseen. Emme käytä henkilökohtaisia tietoja mainostamiseen. Voit muuttaa suostumustasi 15 päivän välein.",
        "learnMore": "Anna minun valita"
      },
      "decline": "kieltäydyn",
      "ok": "Okei",
      "purposes": {
        "essential": {
          "description": "Nämä palvelut ovat välttämättömiä tämän verkkosivuston moitteettoman toiminnan kannalta. Ne sisältävät hakutulosnäkymän ja kieliasetukset, säilyttävät kirjautuneen tilan ja pitävät vierailusi turvassa. Et voi poistaa niitä käytöstä, koska verkkosivusto ei toimisi muuten oikein.",
          "title": "Olennaiset turvallisuus- ja mukautuspalvelut"
        },
        "usage": {
          "description": "Nämä palvelut keräävät tietoja, jotka auttavat meitä ymmärtämään paremmin, miten verkkosivustoa käytetään ja missä kipupisteet ovat, mikä antaa meille mahdollisuuden tehdä tietoon perustuvia valintoja kokemuksesi parantamiseksi.",
          "title": "Palvelut verkkosivuston käytön ja palautteen keräämiseen"
        }
      },
      "service": {
        "disableAll": {
          "description": "Käytä tätä kytkintä kaikkien valinnaisten palveluiden ottamiseen käyttöön tai poistamiseksi käytöstä.",
          "title": "Ota kaikki palvelut käyttöön tai poista ne käytöstä"
        }
      }
    },
    "services": {
      "abTest": {
        "description": "Auttaa parantamaan verkkosivustoamme soveltamalla ajoittain kokeellisia muutoksia.",
        "title": "A/B -testaus"
      },
      "auth-strategy": {
        "description": "Muistaa kirjautumisessa käytettävän valtuutusstrategian.",
        "title": "Auth-strategia"
      },
      "debugSettings": {
        "description": "Auttaa API-pyyntöjen virheenkorjausta",
        "title": "Debug-kytkin"
      },
      "hotjar": {
        "description": "Aktivoi kysely-widget, joka antaa sinulle mahdollisuuden vastata kävijöiden tyytyväisyys tutkimuksiin.",
        "title": "Hotjar"
      },
      "i18n": {
        "description": "Muistaa valitsemasi käyttöliittymäkielen tulevaa käyttöä varten.",
        "title": "Kielikoodi"
      },
      "jira-servicedesk": {
        "description": "Aktivoi palaute-widgetin, jolloin voit ottaa meihin yhteyttä.",
        "title": "Jiran palvelupiste"
      },
      "matomo": {
        "description": "Kerää nimettömiä tilastoja siitä, miten kävijät ovat vuorovaikutuksessa verkkosivuston kanssa.",
        "title": "Matomo"
      },
      "newFeatureNotification": {
        "description": "Näyttää ilmoituksen, kun uusia ominaisuuksia tulee saataville.",
        "title": "Uuden ominaisuuden ilmoitus"
      },
      "searchResultsView": {
        "description": "Muistaa, haluatko nähdä hakutulokset luettelossa tai ruudukkonäkymässä.",
        "title": "Hakutulosnäkymä (luettelo/ruudukko)"
      }
    }
  },
  "layout": {
    "skipToMain": "Siirry sivun sisältöön"
  },
  "learnMore": "Lisätietoja kuvauksen lähteestä",
  "loading": "Ladataan",
  "loadingResults": "Ladataan tuloksia",
  "messages": {
    "copyToClipboardSuccess": "Kopioitu leikepöydälle",
    "externalContentError": "Ulkoisen sisällön lataaminen epäonnistui",
    "notFound": "Ei löydy",
    "paginationLimitExceeded": "Vain ensimmäiset {limit} hakutulosta voidaan näyttää."
  },
  "modal": {
    "download": {
      "clickToCopy": "Kopioi attribuutti napsauttamalla sitä",
      "modalIntro": "Jos käytät tätä kohdetta verkossa tai muualla, älä unohda näyttää seuraavaa attribuutiota sen vieressä:",
      "modalTitle": "Sano kiitos"
    }
  },
  "multilingual": {
    "automated": "Automatisoitu käännös",
    "enrichment": "Rikastaminen kumppaniprojekteilla",
    "other": "Muut kielet",
    "stopTranslating": "Lopeta tämän kohteen kääntäminen kielelle {0}.",
    "translateLanguage": "Haluaisitko nähdä tämän kohteen {0}?",
    "translateQuotaError": "Käännöspalvelu ei ole tilapäisesti käytettävissä. Yritä uudelleen myöhemmin."
  },
  "newFeatureNotification": {
    "dismiss": "Sulje",
    "readMore": "Lue lisää",
    "text": {
      "searchFilters": "Voit nyt etsiä arvoja yksittäisistä suodattimista; Tarkista se!"
    }
  },
  "newWindow": "avautuu uuteen ikkunaan",
  "noMoreResults": "Hakusi ei tuottanut enempää tuloksia.",
  "noResults": "Ei tuloksia",
  "of": "of",
  "organisation": {
    "city": "Kaupunki",
    "country": "Maa",
    "englishName": "Englanninkielinen nimi",
    "nameAcronym": "Nimen lyhenne"
  },
  "pageHasLoaded": "on ladattu",
  "pageNumber": "Sivunumero",
  "pages": {
    "collections": {
      "organisations": {
        "table": {
          "name": "Nimi"
        },
        "title": "Organisaatiot"
      },
      "persons": {
        "title": "Henkilöt"
      },
      "places": {
        "title": "Paikat"
      },
      "table": {
        "items": "Tuotteet",
        "name": "Nimi"
      },
      "times": {
        "title": "aika"
      },
      "topics": {
        "title": "Aiheet"
      }
    }
  },
  "pagination": {
    "label": "Sivunumerointi"
  },
  "readMore": "Lue lisää",
  "recommendation": {
    "prompts": {
      "accept": "Peukalo ylös lisätäksesi galleriaan",
      "reject": "Peukalo alas, jos et pidä siitä"
    }
  },
  "record": {
    "IIIFViewer": "IIIF-katsoja",
    "actions": {
      "pin": "Kiinnitä kohde käytettävissä oleviin Entiteetteihin"
    },
    "allMetaData": "Kaikki metatiedot",
    "copyEmbedLabel": "Upota koodi (kopioi napsauttamalla)",
    "exploreMore": "tutustu",
    "extendedInformation": "Tarkemmat tiedot",
    "goodToKnow": "Hyvä tietää",
    "hideAll": "Piilota kaikki tiedot",
    "location": "Sijainti",
    "locationOnMap": "Sijainti kartalla",
    "mediaPlayer": "Mediasoitin",
    "record": "Tietue",
    "showAll": "Näytä kaikki tiedot",
    "similarItems": "Samanlaisia kohteita",
    "status": {
      "unpublished": "[Julkaisematon kohde]"
    },
    "transcription": "Transkriptio",
    "transcriptionDisclaimer": "Tämän sisällön on lähettänyt yksittäinen henkilö, ei kulttuuriperintölaitos"
  },
  "related": {
    "editorial": {
      "title": "Tarinoita, joista saatat pitää"
    }
  },
  "relatedCollections": "Aiheeseen liittyvät kokoelmat",
  "removeFilter": "Poista {filterLabel} -suodatin",
  "reset": "Nollaa",
  "resourceWikimedia": "Sisältö Wikimedia Commonsista",
  "results": "Tulokset",
  "resultsFor": "Tulokset {0}",
  "resultsLimitWarning": "Enempää tuloksia ei näytetä, koska vain ensimmäiset 1000 merkityksellisintä tulosta näytetään. Jos et löytänyt etsimääsi, voit tarkentaa hakuasi.",
  "resultsWithin": "tulokset {0} {1} sisällä {2}",
  "search": {
    "boost": {
      "placeholder": "Syötä kentän tehostamiskysely"
    },
    "title": "Hae"
  },
  "searchHasLoaded": "{0} tulosta palautettu",
  "searchPlaceholder": "Etsi 50+ miljoonaa kohdetta",
  "searchResults": "Hae",
  "searchResultsFor": "{0} – hae",
  "searchSuggestions": "Hakuehdotuksia",
  "searchTier": {
    "button": {
      "hide": "Piilota kohteet",
      "show": "Näytä kohteet"
    },
    "text": {
      "hide": "Näytetään kohteita, jotka eivät täytä julkaisuehtojamme.",
      "show": "Muutkin kohteet vastaavat hakuasi, mutta ne eivät täytä julkaisuehtojamme."
    }
  },
  "searchViews": {
    "grid": "Ruudukkonäkymä",
    "list": "Luettelonäkymä",
    "mosaic": "Mosaiikkinäkymä"
  },
  "set": {
    "actions": {
      "addTo": "Lisää galleriaan",
      "create": "Luo galleria",
      "createNew": "Luo uusi galleria",
      "delete": "Poista galleria",
      "edit": "Muokkaa galleriaa",
      "update": "Päivitä galleria"
    },
    "form": {
      "description": "Gallerian kuvaus",
      "private": "Pidä tämä galleria yksityisenä",
      "required": "Pakollinen kenttä",
      "title": "Gallerian nimi"
    },
    "labels": {
      "curatedBy": "Kuratoija",
      "private": "Yksityinen galleria"
    },
    "notifications": {
      "deleted": "Galleriasi on poistettu.",
      "likeLimit": {
        "body": "Tykkäysten enimmäismäärä on valitettavasti rajoitettu tällä hetkellä 100 kohteeseen. Poistamme tämän rajoituksen lähiaikoina!",
        "title": "100 tykkäystä"
      },
      "updated": "Kohde on lisätty galleriaan."
    },
    "prompts": {
      "delete": "Haluatko varmasti poistaa tämän gallerian? Jos poistat tämän gallerian, menetät kaikki siihen lisäämäsi kohteet."
    }
  },
  "showLess": "Näytä vähemmän",
  "showMore": "Näytä lisää",
  "sideFilters": {
    "noOptions": "Valittavissa ei ole vaihtoehtoja",
    "search": "Hae"
  },
  "statuses": {
    "liked": "Pidetty",
    "pinned": "Kiinnitetty"
  },
  "storiesPage": {
    "title": "Tarinoita"
  },
  "website": "Verkkosivusto",
  "youMightAlsoLike": "Saatat myös pitää"
};
